import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { COLORS, ROUTES } from '../../config/constants';
import { ChevronRight } from '@vedmarket/ui-kit';

import './page-title.scss';

type PageTitleProps = {
    title: React.ReactNode;
    subcategory?: string;
    subcategoryLink?: string;
};

const PageTitle = ({ title, subcategory, subcategoryLink }: PageTitleProps) => {

    const { t } = useTranslation()

    return (
        <>
            <div className='page-title'>
                <Typography
                    variant='body2'
                    component={Link}
                    to={ROUTES.HOME}
                    sx={{
                        color: COLORS.LIGHT_TEXT_SECONDARY,
                        display: 'inline-block',
                        textDecoration: 'none',
                        lineHeight: '22px'
                    }}
                >
                    {t('common__text__mainPage')}
                </Typography>
                {subcategory && subcategoryLink && (
                    <>
                        <ChevronRight style={{
                            margin: '0 8px',
                            width: '20px',
                            height: '20px',
                        }}/>
                        <Typography
                            variant='body2'
                            component={Link}
                            to={subcategoryLink}
                            sx={{
                                color: COLORS.LIGHT_TEXT_SECONDARY,
                                display: 'inline-block',
                                textDecoration: 'none',
                                lineHeight: '22px'
                            }}
                        >
                            {subcategory}
                        </Typography>
                    </>
                )}
            </div>

            <Typography variant='h4' sx={{
                fontWeight: 700,
                letterSpacing: 0,
                fontSize: '32px',
                lineHeight: '40px'
            }}>
                {title}
            </Typography>
        </>
    )
};

export default PageTitle;
